import {
  Button,
  Checkbox,
  ConfigProvider,
  DatePicker,
  Pagination,
  Radio,
  RadioChangeEvent,
  Select,
  Switch,
  Tabs,
  TabsProps,
  Tooltip,
} from "antd";
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import TonalStatistic from "../components/TonalStatistic";
import {
  backRemovedPost,
  changePostPage,
  feedFilterClear,
  feedFilterSubmit,
  fetchPosts,
  fetchStopPost,
  removeRefPost,
  setProduct,
  setReferences,
  setReferencesFilter,
} from "../redux/actions";
import {
  getPostCount,
  getPostIsLoading,
  getPostList,
  getPostPageNumber,
  getPostPageSize,
  getProduct,
  getReferencesFilter,
  getReferences,
  getThread,
  getMainProduct,
  getProducts,
} from "../redux/selectors";
import { useAppDispatch } from "../redux/store/hooks";
import locale from "antd/es/date-picker/locale/ru_RU";
import { getFeedFilter } from "../redux/selectors/feed-filter.selectors";
import {
  CloseOutlined,
  DeleteOutlined,
  LoadingOutlined,
} from "@ant-design/icons";
import Post from "../components/post";
import IconUndo from "../components/icons/undo";
import IconChecked from "../components/icons/checked";
import FeedStatistics from "../components/feed-statistics/feed-statistics";
import CustomSelectBySources from "../components/custom-select-by-sources";
import { postService } from "../api";
import "dayjs/locale/ru";
import dayjs from "dayjs";

const Thread = () => {
  const [value, setValue] = useState("today");
  const { RangePicker } = DatePicker;
  const mainProduct = useSelector(getMainProduct);
  const feedFilter = useSelector(getFeedFilter);
  const [tonality, setTonality] = useState(feedFilter.tonal);
  const [tonal, setTonal] = useState();
  const [repostOption, setRepostOption] = useState(feedFilter.repostoption);
  const [friendly, setFriendly] = useState(feedFilter.friendly);
  const [sorting, setSorting] = useState(feedFilter.sort);
  const [switchValue, setSwitchValue] = useState(false);
  const [checkedPosts, setCheckedPosts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [tab, setTab] = useState("post");
  const [competitors, setCompetitors] = useState([]);
  const referencesFilter = useSelector(getReferencesFilter);
  const references = useSelector(getReferences);
  const [dateString, setDateString] = useState([
    feedFilter.from,
    feedFilter.to,
  ]);
  const isLoading = useSelector(getPostIsLoading);
  const postList = useSelector(getPostList);
  const postCount = useSelector(getPostCount);
  const pageNumber = useSelector(getPostPageNumber);
  const [profileId, setProfileId] = useState(feedFilter.profile_id);
  const [location, setLocation] = useState(window.location.search);
  const [refSourceList, setRefSourceList] = useState<any>([]);
  const pageSize = useSelector(getPostPageSize);
  const thread = useSelector(getThread);

  let netOptions:any = []
    if (thread?.networks?.includes(1)) netOptions.push({ value: "vk", label: "ВКонтакте" })
    //if (thread?.networks?.includes(2)) netOptions.push({ value: "tw", label: "Twitter" })
    //if (thread?.networks?.includes(3)) netOptions.push({ value: "fb", label: "Facebook" })
    if (thread?.networks?.includes(5)) netOptions.push({ value: "tg", label: "Telegram" })
    //if (thread?.networks?.includes(7)) netOptions.push({ value: "ig", label: "Instagram" })
    if (thread?.networks?.includes(8)) netOptions.push({ value: "yt", label: "Youtube" })
    if (thread?.networks?.includes(10)) netOptions.push({ value: "ok", label: "Одноклассники" })
    if (thread?.networks?.includes(11)) netOptions.push({ value: "dz", label: "Дзен" })
    if (thread?.networks?.includes(4)) netOptions.push({ value: "smi", label: "СМИ" })
  const options = [
    { label: " Другое", value: "period" },
    { label: "Сегодня", value: "today" },
    { label: "7д", value: "week" },
    { label: "1м", value: "month" },
  ];
  const [source, setSource] = useState({
    smi: feedFilter.smi,
    vk: feedFilter.vk,
    tw: feedFilter.tw,
    ig: feedFilter.ig,
    tg: feedFilter.tg,
    yt: feedFilter.yt,
    dz: feedFilter.dz,
    ok: feedFilter.ok,
    fb: feedFilter.fb,
  });
  const [sourceChange, setSourceChange] = useState({
    smi: feedFilter.smi,
    vk: feedFilter.vk,
    tw: feedFilter.tw,
    ig: feedFilter.ig,
    tg: feedFilter.tg,
    yt: feedFilter.yt,
    dz: feedFilter.dz,
    ok: feedFilter.ok,
    fb: feedFilter.fb,
  });
  const [sourceOptions, setSourceOptions] = useState([
    "tg",
    "vk",
    "ok",
    "fb",
    "tw",
    "yt",
    "dz",
    "ig",
    "smi",
  ]);

  const product = useSelector(getProduct);
  const products = useSelector(getProducts);
  const dispatch = useAppDispatch();

  useEffect(() => {
    const queryString = location;
    if (!queryString.length) {
      onClear();
    }
    const params: any = new URLSearchParams(queryString);
    const querySource = params.get("source");
    const queryFrom = params.get("from");
    const queryTo = params.get("to");
    const queryProfile = params.get("profile_id");
    const queryTonal = params.get("tonal");

    if (queryProfile?.length > 1) {
      setDateString([queryFrom, queryTo]);
      setTimeout(() => handleChangeProfile(queryProfile), 1000);
      dispatch(changePostPage(1));
      setValue("period");
    }

    if (queryTonal?.toString().length > 0) {
      setDateString([queryFrom, queryTo]);
      setTimeout(() => setTonality(queryTonal), 1000);
      dispatch(changePostPage(1));
      setValue("period");
    }

    if (querySource?.length > 1) {
      setDateString([queryFrom, queryTo]);
      setValue("period");
      setTimeout(
        () =>
          setSource(() => ({
            smi: false,
            vk: false,
            tw: false,
            fb: false,
            ig: false,
            tg: false,
            yt: false,
            dz: false,
            ok: false,
            [querySource]: true,
          })),
        1000
      );
      handleChangeSource([querySource]);
      dispatch(changePostPage(1));
    }
  }, [location]);

  useEffect(() => {
    if (thread) {
      setLoading(true);
      postService
        .loadRefSources({
          start: 0,
          thread_id: thread?.id,
          limit: 300,
          referenceFilter: referencesFilter,
          network_id: [1, 4, 5, 8, 10],
        })
        .then((result) => {
          setRefSourceList(
            result.items.filter(
              (it: any) => !it?.title?.includes("проиндексировано")
            )
          );
          setLoading(false);
        })
        .catch(() => {
          setLoading(false);
          setRefSourceList([]);
        });
    }
  }, [referencesFilter, thread]);

  useEffect(() => {
    if (products.length > 0 && mainProduct.id) {
      setLoading(true);
      let compArr: any = [];
      compArr = [
        ...products?.find((it: any) => it.id == mainProduct?.id)?.competitor,
      ];
      setCompetitors(compArr);
      setLoading(false);
    }
  }, [products, mainProduct]);

  useEffect(() => {
    dispatch(
      feedFilterSubmit({
        from: dateString[0]?.slice(0, 10) + " 00:00:00",
        to: dateString[1]?.slice(0, 10) + " 23:59:59",
        smi: (thread?.networks?.includes(4)) && source.smi,
        vk: (thread?.networks?.includes(1)) && source.vk,
        tw: (thread?.networks?.includes(2)) && source.tw,
        fb: (thread?.networks?.includes(3)) &&  source.fb,
        ig: (thread?.networks?.includes(7)) &&  source.ig,
        tg: (thread?.networks?.includes(5)) &&  source.tg,
        yt: (thread?.networks?.includes(8)) &&  source.yt,
        dz: (thread?.networks?.includes(11)) &&  source.dz,
        ok: (thread?.networks?.includes(10)) &&  source.ok,
        tonal: tonality,
        friendly: friendly,
        sorting: sorting,
        profile_id: profileId,
        repostoption: repostOption,
      })
    );
    if (thread && tab == "post") dispatch(fetchPosts());
    if (thread && tab == "stop") dispatch(fetchStopPost());
  }, [
    source,
    dateString,
    sorting,
    tonality,
    thread,
    repostOption,
    product,
    tab,
    profileId,
  ]);

  const onClear = (): void => {
    setDateString([
      new Date().toJSON().split("T")[0],
      new Date().toJSON().split("T")[0],
    ]);
    setSource({
      smi: true,
      vk: true,
      tw: true,
      fb: true,
      ig: true,
      tg: true,
      yt: true,
      dz: true,
      ok: true,
    });
    setValue("today");
    setSourceOptions(["tg", "vk", "ok", "yt", "dz", "smi"]);
    setTonality(null);
    setFriendly("");
    setSorting(null);
    setRepostOption("whatever");
    setSwitchValue(false);
    dispatch(feedFilterClear());
    dispatch(changePostPage(1));
    setProfileId("");
  };

  const onChangeRepost = (checked: boolean) => {
    setRepostOption(checked ? "containrepost" : "whatever");
    setSwitchValue(checked);
  };

  const getNetworkName = (id: any) => {
    if (id == 4) return "сми: ";
    if (id == 1) return "vk: ";
    if (id == 2) return "tw: ";
    if (id == 5) return "tg: ";
    if (id == 8) return "yt: ";
    if (id == 10) return "ok: ";
    if (id == 11) return "dz: ";
  };

  const getTitle = (title: any, id: any) => {
    if (id == 4 && title?.toUpperCase().slice(0, 11) == "КОММЕРСАНТЪ")
      return title.slice(0, 11);
    else return title;
  };

  let allItems = refSourceList.map((it: any) => ({
    id: [it.profile_id + it.network_id].toString(),
    keyword: getNetworkName(it.network_id) + getTitle(it.title, it.network_id),
  }));

  const onChange = ({ target: { value } }: RadioChangeEvent) => {
    setValue(value);

    if (value == "today")
      setDateString([
        new Date().toJSON().split("T")[0],
        new Date().toJSON().split("T")[0],
      ]);
    if (value == "week") {
      const start = new Date();
      start.setDate(start.getDate() - 6);
      setDateString([
        start.toJSON().split("T")[0],
        new Date().toJSON().split("T")[0],
      ]);
    }
    if (value == "month") {
      const start = new Date();
      start.setDate(start.getDate() - 29);
      setDateString([
        start.toJSON().split("T")[0],
        new Date().toJSON().split("T")[0],
      ]);
    }
  };

  const onPeriodChange = (value: any, dateString: string[]): void => {
    setDateString([
      dateString[0].split(".")[2] +
        "-" +
        dateString[0].split(".")[1] +
        "-" +
        dateString[0].split(".")[0],
      dateString[1].split(".")[2] +
        "-" +
        dateString[1].split(".")[1] +
        "-" +
        dateString[1].split(".")[0],
    ]);
    dispatch(changePostPage(1));
  };

  const handleChangeSort = (value: string) => {
    setSorting(value);
    dispatch(changePostPage(1));
  };

  const handleChangeTonal = (value: string) => {
    setTonality(value);
    dispatch(changePostPage(1));
  };

  const handleChangeProfile = (value: any) => {
    setProfileId(value);
    dispatch(changePostPage(1));
  };

  const handleChangeSource = (value: string[]) => {
    for (let key in source) {
      value.indexOf(key) != -1
        ? setSourceChange((prevState) => ({
            ...prevState,
            [key]: true,
          }))
        : setSourceChange((prevState) => ({
            ...prevState,
            [key]: false,
          }));
    }
    setSourceOptions(value);
    //dispatch(changePostPage(1));
  };

  const changeSources = () => {
    setSource(sourceChange);
    dispatch(changePostPage(1));
  };

  const onCheck: any = (target: any, post: any) => {
    let checkedPostsArr: any = [...checkedPosts];
    if (target == true) checkedPostsArr.push(post);
    else if (target == false) {
      const filteredNumbers = checkedPostsArr.filter(
        (it: any) => it.id !== post.id
      );
      checkedPostsArr = filteredNumbers;
    }
    setCheckedPosts(checkedPostsArr);
  };

  const selectAll = () => {
    let checkedPostsArr: any = [];
    postList?.forEach((post) => checkedPostsArr.push(post));
    setCheckedPosts(checkedPostsArr);
  };

  const deleteAll = () => {
    if (tab == "post")
      checkedPosts?.forEach((post: any) => {
        dispatch(
          removeRefPost(post.id, post.ownerId, post.network.id, references[0])
        );
        setCheckedPosts([]);
      });
    if (tab == "stop")
      checkedPosts?.forEach((post: any) => {
        dispatch(
          backRemovedPost(post.id, post.ownerId, post.network.id, references[0])
        );
        setCheckedPosts([]);
        //dispatch(removeThreadPost(post.id, post.ownerId, post.network.id))
      });
    if (thread && tab == "post") dispatch(fetchPosts());
    if (thread && tab == "stop")
      setTimeout(() => dispatch(fetchStopPost()), 1000);
  };

  const items: TabsProps["items"] = [
    {
      key: "post",
      label: "Посты",
      //children: 'Content of Tab Pane 1',
    },
    {
      key: "stop",
      label: "Исключенные",
      //children: 'Content of Tab Pane 2',
    },
  ];

  const onChangeTab = (key: string) => {
    setTab(key);
    dispatch(changePostPage(1));
  };

  const changeTonal = (value: any) => {
    setTonal(value);
  };

  return (
    <div className="App">
      <h1>Лента постов</h1>
      {!isLoading ? (
        <div className="btn-group">
          <Button
            type={references == mainProduct?.client?.id ? "primary" : "default"}
            onClick={() => {
              onChangeTab("post");
              dispatch(changePostPage(1));
              dispatch(setReferences([mainProduct?.client?.id]));
              dispatch(setReferencesFilter([mainProduct?.client?.id]));
              if (thread) dispatch(fetchPosts());
              setTab("post");
            }}
          >
            {mainProduct?.client?.title}
          </Button>
          {competitors
            ?.sort((a: any, b: any) => a.title.localeCompare(b.title))
            ?.map((competitor: any, id) => (
              <Button
                key={id}
                type={references == competitor?.id ? "primary" : "default"}
                onClick={() => {
                  onChangeTab("post");
                  dispatch(changePostPage(1));
                  dispatch(setReferences([competitor?.id]));
                  dispatch(setReferencesFilter([competitor?.id]));
                  let prod = products.find(
                    (it: any) => it?.client?.id == competitor.id
                  )?.id;
                  dispatch(setProduct(prod));
                  if (thread) dispatch(fetchPosts());
                  setTab("post");
                }}
              >
                {competitor?.title}
              </Button>
            ))}
        </div>
      ) : (
        <div className="feed-posts-loader">
          <LoadingOutlined />
        </div>
      )}
      <TonalStatistic tonal={tonal} />
      {!isLoading && (
        <Tabs
          className="tabs-group"
          defaultActiveKey={tab}
          items={items}
          onChange={onChangeTab}
        />
      )}
      <div className="white-block">
        {tab == "post" && (
          <>
            <FeedStatistics referencesFilter={referencesFilter} />
            <div className="flex-space">
              <div className="flex">
                <ConfigProvider
                  theme={{
                    components: {
                      Select: {
                        activeBorderColor: "#7856FE",
                      },
                    },
                  }}
                >
                  <Select
                    style={{ width: 150 }}
                    allowClear={false}
                    onChange={handleChangeSort}
                    disabled={isLoading}
                    options={[
                      { value: "dateAsc", label: "Сначала старые" },
                      { value: "dateDesc", label: "Сначала новые" },
                      { value: "viewDesc", label: "Больше просмотров" },
                      { value: "viewAsc", label: "Меньше просмотров" },
                      { value: "comDesc", label: "Больше комментариев" },
                      { value: "comAsc", label: "Меньше комментариев" },
                      { value: "repostDesc", label: "Больше репостов" },
                      { value: "repostAsc", label: "Меньше репостов" },
                      { value: "likeDesc", label: "Больше лайков" },
                      { value: "likeAsc", label: "Меньше лайков" },
                    ]}
                    placeholder="Сортировать по"
                  />
                </ConfigProvider>
                <ConfigProvider
                  theme={{
                    components: {
                      Select: {
                        activeBorderColor: "#7856FE",
                      },
                    },
                  }}
                >
                  <Select
                    value={sourceOptions}
                    mode="multiple"
                    allowClear={true}
                    style={{ width: 180 }}
                    maxTagCount={"responsive"}
                    disabled={isLoading}
                    options={netOptions}
                    placeholder="Тип источника"
                    dropdownRender={(menu) => (
                      <>
                        {menu}

                        <Button type="text" onClick={changeSources}>
                          Применить
                        </Button>
                      </>
                    )}
                    onChange={handleChangeSource}
                    maxTagPlaceholder={(omittedValues) => (
                      <Tooltip
                        color={"#7856FE"}
                        overlayStyle={{ pointerEvents: "none" }}
                        title={omittedValues
                          .map(({ label }) => label)
                          .join(", ")}
                      >
                        <span>Выбранные источники</span>
                      </Tooltip>
                    )}
                  />
                </ConfigProvider>
                {/*<CustomSelectBySources
                  items={allItems}
                  onChange={handleChangeProfile}
                  value={profileId}
                  isLoading={isLoading}
                  withSearch={true}
                        />*/}
                <ConfigProvider
                  theme={{
                    components: {
                      Select: {
                        activeBorderColor: "#7856FE",
                      },
                    },
                  }}
                >
                  <Select
                    style={{ width: 150 }}
                    allowClear={false}
                    onChange={handleChangeTonal}
                    disabled={isLoading}
                    value={tonality ? tonality : null}
                    options={[
                      { value: null, label: "Все" },
                      { value: "1", label: "Позитивные" },
                      { value: "-1", label: "Негативные" },
                      { value: "0", label: "Нейтральные" },
                      /*{ value: "unset", label: "Не задана" },*/
                    ]}
                    placeholder="Тональность"
                  />
                </ConfigProvider>
                <div className="left-border">
                  <p className={isLoading ? "grey" : ""}>Наличие репоста</p>
                  <ConfigProvider
                    theme={{
                      token: {
                        colorPrimary: "#D8CCFB",
                        colorPrimaryHover: "#D8CCFB",
                        colorTextTertiary: "rgba(0, 0, 0, 0.2)",
                        colorTextQuaternary: "rgba(0, 0, 0, 0.1)",
                        fontSize: 10,
                      },
                      components: {
                        Switch: {
                          handleSize: 22,
                          trackPadding: -2,
                        },
                      },
                    }}
                  >
                    <Switch
                      value={switchValue}
                      onChange={onChangeRepost}
                      disabled={isLoading}
                    />
                  </ConfigProvider>
                </div>
              </div>

              <div className="flex">
                <ConfigProvider
                  theme={{
                    components: {
                      Radio: {
                        buttonSolidCheckedColor: "#7856FE",
                        buttonSolidCheckedBg: "rgba(0, 0, 0, 0.1)",
                        colorPrimary: "rgba(0, 0, 0, 0.1)",
                        buttonSolidCheckedHoverBg: "rgba(0, 0, 0, 0.2)",
                      },
                    },
                  }}
                >
                  <Radio.Group
                    options={options}
                    onChange={onChange}
                    value={value}
                    optionType="button"
                    buttonStyle="solid"
                    disabled={isLoading}
                  />
                </ConfigProvider>

                {value == "period" && (
                  <RangePicker
                    format={"DD.MM.YYYY"}
                    onChange={onPeriodChange}
                    style={{ width: "278px" }}
                    className="choose-period"
                    allowClear={false}
                    value={[dayjs(dateString[0]), dayjs(dateString[1])]}
                    locale={locale}
                  />
                )}
              </div>
            </div>
          </>
        )}

        <div className="feed-posts">
          {isLoading && (
            <div className="feed-posts-loader">
              <LoadingOutlined />
            </div>
          )}
          {!isLoading && postCount > 0 && (
            <>
              <div className="flex">
                <div className="grey">
                  Всего постов: {(+postCount).toLocaleString()}
                </div>
                {tab == "post" && (
                  <p onClick={onClear} className="flex clear">
                    Очистить фильтры <CloseOutlined className="info" />
                  </p>
                )}
              </div>
              <div className="post-list">
                {postList?.map((item, id) => (
                  <div className="flex" key={id}>
                    <ConfigProvider
                      theme={{
                        token: {
                          colorPrimary: "#7856FE",
                          colorPrimaryHover: "rgba(0, 0, 0, 0.1)",
                          controlInteractiveSize: 25,
                        },
                      }}
                    >
                      <Checkbox
                        checked={
                          checkedPosts.findIndex(
                            (it: any) => it.id == item.id
                          ) != -1
                        }
                        onChange={(e) => onCheck(e.target.checked, item)}
                      ></Checkbox>
                    </ConfigProvider>
                    <Post key={item.id} post={item} changeTonal={changeTonal} />
                  </div>
                ))}
              </div>
              {postCount > 0 ? (
                <div className="feed-posts-pagination">
                  <Pagination
                    size="small"
                    onChange={(value) => {
                      dispatch(changePostPage(value));
                      if (thread && tab == "post") dispatch(fetchPosts());
                      if (thread && tab == "stop") dispatch(fetchStopPost());
                    }}
                    total={postCount}
                    pageSize={pageSize}
                    current={pageNumber}
                    hideOnSinglePage={true}
                    showSizeChanger={false}
                  />
                </div>
              ) : null}
            </>
          )}
          {!isLoading && postCount == 0 && (
            <div className="flex">
              <div className="feed-posts__empty">Постов пока нет</div>
              <p onClick={onClear}>
                Очистить фильтры <CloseOutlined className="info" />
              </p>
            </div>
          )}
        </div>
      </div>
      {checkedPosts.length > 0 && (
        <div className="fixed-block flex-space">
          <div className="flex">
            <a onClick={selectAll} className="flex btn-cursor">
              <IconChecked />
              Выбрать все
            </a>
            <a onClick={() => setCheckedPosts([])} className="flex btn-cursor">
              <IconUndo />
              Сбросить
            </a>
          </div>
          <div className="flex">
            <div className="grey">Постов выбрано: {checkedPosts.length}</div>
            <div className="red-bg red btn-cursor" onClick={deleteAll}>
              <DeleteOutlined />{" "}
              {tab == "post" ? "Исключить" : "Вернуть в ленту"}
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default Thread;
